package DataBase

/**
 * Per-platform policy for order writes.
 *
 * The server bumps `row_version` on every order update and only checks the optimistic lock
 * (→ `VERSION_CONFLICT`) when the request carries a positive `row_version`
 * (`orders_realtime.apply_order_row_version`). Platforms that want "last write wins" set
 * [sendRowVersion] to false at startup and never see a conflict.
 *
 * Web (nexilcolab) keeps the default `true`; the Android and KMP mobile apps set `false`.
 */
object OrderWritePolicy {
    /** When false, order updates omit `row_version` and always overwrite the server copy. */
    var sendRowVersion: Boolean = true

    /** `row_version` to send for a single-order update, or null to skip the lock. */
    fun forUpdate(cachedVersion: Int?): String? =
        if (sendRowVersion && cachedVersion != null && cachedVersion > 0) cachedVersion.toString() else null

    /** `row_version` to send for one item of a batch update, or null to skip the lock. */
    fun forBatchItem(explicit: Int?, cached: Int?): Int? {
        if (!sendRowVersion) return null
        return explicit?.takeIf { it > 0 } ?: cached?.takeIf { it > 0 }
    }
}
